<template>
    <div class="shareModal">
        <!-- 分享弹窗 -->
        <dsh-modal
            v-model="showModal"
            :propsObj="shareModalPropsObj"
            mode="small"
        >
            <div class="share">
                <div class="share-duration">
                    <span class="share-label">分享时限:</span>
                    <dsh-select class="share-operation" style="margin-left:30px"  :value="durationVal" :propsObj="selectPropsObj">
                    </dsh-select>
                </div>
                <div class="share-role" v-if="pageType=='app'">
                    <span class="share-label">角色权限:</span>
                    <Select v-model="role" style="padding:0 50px">
                        <Option v-for="item in rolesList" :value="item._id" :key="item._id">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="share-type">
                    <span class="share-label">分享方式:</span>
                    <div class="share-operation">
                        <div class="share-operation-item" @click="createShare('link')">
                            <div class="share-type-logo" style="">
                                <Icon type="ios-link" size="35" color="#fff"/>
                            </div>
                            <span class="share-type-text">链接</span>
                        </div>
                        <div class="share-operation-item" @click="createShare('erweima')">
                            <div>
                                <img :src="$imageSrcMap.mod.erweima" alt="" style="width:50px;height:50px">
                            </div>
                            <span class="share-type-text">二维码</span>
                        </div>
                    </div>
                </div>
            </div>
        </dsh-modal>
        <dsh-modal
            v-model="linkModal"
            :propsObj="linkModalPropsObj"
            mode="small"
        >
            <div class="linkmodal-content">
                <div class="linkmodal-content-desc">{{shareLink}}  <a @click="goShareLink">点击跳转</a></div>
                <dsh-buttons
                    style="margin-top:120px;"
                    :list="$getOperationList(['closeLink', 'copy'])"
                    @click="$dispatchEvent($event)"
                ></dsh-buttons>
            </div>
        </dsh-modal>
        <dsh-modal
            v-model="qrCodeModal"
            :propsObj="qrCodeModalPropsObj"
            mode="small"
        >
            <div class="qrcodemodal-content">
                <div ref="qrcode" class="qrcode"></div>
                <dsh-buttons
                    :list="$getOperationList(['close', 'download'])"
                    @click="$dispatchEvent($event)"
                ></dsh-buttons>
            </div>
        </dsh-modal>
    </div>
</template>

<script>
    import QRCode from "qrcodejs2";

    export default {
        name: "shareModal",
        props: {
            companyId: String,
            appId: String,

            dataId: String | Number,
            canEdit: {
                type: Boolean,
                default: true
            },
            value: Boolean,
            refKey: String,
            screenKey: String,
            isCreate: Boolean,
            pageType: {
                type: String,
                default: "mod"
            },
            defaultData: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            rolesList: Array
        },
        data () {
            return {
                qrCodeModal: false,
                shareModalPropsObj: {
                    title: "分享"
                },
                durationVal: {
                    duration: 1
                },

                shareLink: "",
                qrCodeModalPropsObj: {
                    title: "分享二维码"
                },
                linkModal: false,
                linkModalPropsObj: {
                    title: "分享链接"
                },
                qrcode: null,
                operationMap: {
                    close: {
                        name: "取消",
                        type: "close",
                        size: "large",
                        event: "clickClose"
                    },
                    download: {
                        name: "下载",
                        type: "download",
                        size: "large",
                        style: "background:#3DB8C5;color:#fff;margin-left:50px",
                        event: "clickDownload"
                    },
                    closeLink: {
                        name: "取消",
                        type: "close",
                        size: "large",
                        event: "clickCloseLink"
                    },
                    copy: {
                        name: "复制",
                        type: "download",
                        style: "background:#3DB8C5;color:#fff;margin-left:50px",
                        size: "large",
                        event: "clickCopy"
                    }
                },
                role: "",
                appName: "",
                shareItemName: ""
            };
        },
        computed: {
            showModal: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit("input", val);
                }
            },
            selectPropsObj () {
                let _data = [
                    {
                        _key: 1,
                        name: "24小时"
                    },
                    {
                        _key: 7,
                        name: "7天"
                    },
                    {
                        _key: 15,
                        name: "15天"
                    },
                    {
                        _key: 30,
                        name: "30天"
                    },
                    {
                        _key: "Infinity",
                        name: "无限期"
                    }
                ];
                if (this.pageType == "app") _data.pop();
                return {
                    _key: "duration",
                    _optionKind: "flat",
                    _data
                };
            }
        },
        created () {
        },
        methods: {
            createShare (type) {
                if (!this.durationVal.duration) return this.$Message.error("请选择分享时限");
                let operationType = this.canEdit ? "edit" : "show";
                if (this.isCreate) {
                    operationType = "create";
                }
                let params = {
                    pageType: this.pageType,
                    duration: this.durationVal.duration
                };
                if (this.pageType == "app") {
                    if (!this.role) {
                        return this.$Message.error("请选择角色权限");
                    }
                    params = {
                        ...params,
                        role: this.role
                    };
                } else {
                    params = {
                        ...params,
                        refKey: this.refKey,
                        operationType,
                        dataId: this.isCreate ? undefined : this.dataId,
                        screenKey: this.screenKey,
                        ...this.defaultData
                    };
                }
                this.$https({
                    url: {
                        module: "share",
                        name: "createLink"
                    },
                    params,
                    callback: data => {
                        this.appName = data.appName;
                        this.shareItemName = data.name;
                        this.shareLink = data.shareLink;
                        if (type == "link") {
                            this.linkModal = true;
                        } else {
                            this.qrCodeModal = true;
                            this.$refs.qrcode.innerHTML = "";
                            this.qrcode = new QRCode(this.$refs.qrcode, {
                                text: this.shareLink, // 需要生成二维码的内容
                                width: 147,
                                height: 147,
                                colorDark: "#000000",
                                colorLight: "#ffffff"
                            });

                        }
                    }
                });

            },
            clickClose () {
                this.qrCodeModal = false;
            },
            clickDownload () {
                const imgUrl = this.qrcode._el.children[1].getAttribute("src");
                const a = document.createElement("a");
                a.href = imgUrl;
                a.setAttribute("download", "分享二维码");
                a.click();
            },
            clickCloseLink () {
                this.linkModal = false;
            },
            clickCopy (text) {
                let oInput = document.createElement("input");
                oInput.value = `${this.appName}-${this.shareItemName},请在${this.selectPropsObj._data.find(item => item._key === this.durationVal.duration).name}内查看链接中内容，链接为${this.shareLink}`;
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                oInput.style.display = "none";
                document.body.removeChild(oInput);
                this.$Message.success("成功复制到剪切板");
            },
            goShareLink () {
                window.open(this.shareLink, "_blank");
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/share/shareModal.vue